import cn from 'classnames';
import Image, { StaticImageData } from 'next/image';
import { useRef, useState } from 'react';
import Slider, { Settings } from 'react-slick';
import ArrowLeft from '../../public/slider-arrow-left.svg';
import ArrowRight from '../../public/slider-arrow-right.svg';
import staticComments from '../../utils/comments';
import styles from './logistic-slider.module.css';

export interface LogisticSlideProps {
  name: string;
  company: string;
  text: string;
  img: string | StaticImageData;
}

function LogisticSlide({ name, company, text, img }: LogisticSlideProps) {
  return (
    <div className={styles.slide}>
      <div className={styles.slide__row}>
        <div className={styles.slide__image}>
          <Image
            alt={name}
            width={92}
            height={92}
            src={img}
            style={{ objectFit: 'cover' }}
          />
        </div>

        <div className={styles.slide__col}>
          <div className={styles.slide__name}>{name}</div>
          <div className={styles.slide__position}>{company}</div>
        </div>
      </div>
      <div className={styles.slide__text}>{text}</div>
    </div>
  );
}

export default function LogisticSlider() {
  const sliderRef = useRef<any>();
  const [index, setIndex] = useState(1);

  const settings: Settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    beforeChange: (_, current) => setIndex(current),
  };
  return (
    <div className={styles.slider}>
      <Slider className={styles.wrapper} ref={sliderRef} {...settings}>
        {staticComments.map((slide, i) => (
          <LogisticSlide key={i} {...slide} />
        ))}
      </Slider>
      <div className={styles.footer}>
        <span
          aria-hidden="true"
          className={cn(styles.button, styles['button--left'])}
          onClick={() => {
            if (sliderRef) {
              sliderRef?.current?.slickPrev();
            }
          }}
        >
          <ArrowLeft />
        </span>
        <span>{`${index + 1}/${staticComments.length}`}</span>
        <span
          aria-hidden="true"
          className={cn(styles.button, styles['button--right'])}
          onClick={() => {
            if (sliderRef) {
              sliderRef?.current?.slickNext();
            }
          }}
        >
          <ArrowRight />
        </span>
      </div>
    </div>
  );
}
